<script setup lang="ts">
  // import { $t } from '@/locales';
  import UserAvatar from "../global-header/components/user-avatar.vue";
  defineOptions({
    name: "GlobalLogo",
  });

  interface Props {
    /** Whether to show the title */
    showTitle?: boolean;
    direction: string;
  }

  const props = withDefaults(defineProps<Props>(), {
    showTitle: true,
  });
</script>

<template>
  <div class="w-full flex-center nowrap-hidden min-w-[64px]">
    <UserAvatar :show-title="props.showTitle" :direction="direction" />
  </div>
</template>

<style scoped></style>
